import { render, staticRenderFns } from "./dataPrivilegeDiv.vue?vue&type=template&id=21509740&scoped=true"
import script from "./dataPrivilegeDiv.vue?vue&type=script&lang=js"
export * from "./dataPrivilegeDiv.vue?vue&type=script&lang=js"
import style0 from "./dataPrivilegeDiv.vue?vue&type=style&index=0&id=21509740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21509740",
  null
  
)

export default component.exports